import styled from 'styled-components'

import { ORDER_ITEM_STATUS_VALUE } from '../../../../helpers'
import { COLOR, FONT_SIZE, NATIVE_BASE_COLORS } from '../../../../themes'

const statusColor = (status = '') => {
  const style = {
    color: COLOR.BLACK,
    backgroundColor: '',
    padding: '2px 4px',
  }

  switch(status) {
    case ORDER_ITEM_STATUS_VALUE.WAITING:
      style.color = NATIVE_BASE_COLORS.WARNING[700]
      style.backgroundColor = NATIVE_BASE_COLORS.WARNING[100]
      break

    case ORDER_ITEM_STATUS_VALUE.ON_GOING:
      style.color = NATIVE_BASE_COLORS.INFO[700]
      style.backgroundColor = NATIVE_BASE_COLORS.INFO[100]
      break

    case ORDER_ITEM_STATUS_VALUE.COMPLETE:
      style.color = NATIVE_BASE_COLORS.SUCCESS[700]
      style.backgroundColor = NATIVE_BASE_COLORS.SUCCESS[100]
      break

    default:
  }
  
  return style
}

export const OrderItemStyle = styled.div`
  padding: 16px 0px 16px 0px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;

  p {
    margin: 0;
  }

  .order-item__box {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .order-item__top-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .order-item__order {
    &--number {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: ${FONT_SIZE.SM};
      font-family: NunitoSansSemiBold;
      height: 32px;
    }

    &--status {
      ${props => statusColor(props.status)};
      font-family: NunitoSansBold;
      border-radius: 4px;
      font-size: ${FONT_SIZE.TN};
    }
  }

  .order-item__order-duration {
    font-size: ${FONT_SIZE.TN};
    color: ${NATIVE_BASE_COLORS.TEXT[500]};
  }
  
  .order-item__order-list {
    display: flex;
    flex-direction: column;
    gap: 16px;

    &__item {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
  }

  .order-item__button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 32px;
    gap: 24px;

    button {
      cursor: pointer;
    }

    &--edit {
      font-size: ${FONT_SIZE.XXS};
      font-family: NunitoSansBold;
      background: none;
      color: ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
      border: 1px solid ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
      border-radius: 4px;
      padding: 4px 16px;
    }

    &--delete {
      display: flex;
      align-items: center;
      background: none;
      border: none;
      padding: 0;
    }
  }

  .disabled {
    display: none;
  }
`
